import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { ValidateSirenQuery } from '../../../generated/graphql'

export const validateSiren = getQueryService({
  query: gql`
    query validateSiren($siren: String!) {
      validateSiren(siren: $siren) {
        address
        city
        postalCode
        companyName
      }
    }
  `,
  transformer: (response: ValidateSirenQuery) => {
    return response.validateSiren
  },
})
